document.addEventListener('keydown', (e) => {
  if (e.which === 9) {
    document.body.classList.add('keyboard-navigation')
  }
})

document.addEventListener('mouseup', (e) => {
  document.body.classList.remove('keyboard-navigation')
})
